import * as React from "react";
import { Row, Col } from "reactstrap";
import { GoogleAnalyticsService } from "src/share/services/ga";
import { useInterval } from "src/share/hooks/useInterval";

export interface IGAActiveUsersProps {
  pagePath: string;
  views: {
    query: {
      ids: string
    }
  }
}
export interface IGAActiveUsersState {
  activeUsers: number | null;
  pageViews: number | null;
}

export const GAHeaderStats: React.SFC<IGAActiveUsersProps> = (props) => {
  const [activeUsers, setActiveUsers] = React.useState<number | null>(null);
  const [pageViews, setPageViews] = React.useState<number | null>(null);
  const [counter, setCounter] = React.useState(0);
  const { clear } = useInterval(async () => {
    try {
      const activeUsersResponse = await GoogleAnalyticsService.getActiveUsers(props.views.query.ids, props.pagePath);
      setActiveUsers(activeUsersResponse);
    } catch (e) {
      setCounter(prevCounter => prevCounter + 1);
    }
  }, 10000);
  React.useEffect(() => {
    if (counter >= 3) {
      clear();
    }
  }, [counter]);
  React.useEffect(() => {
    poolData();
  }, []);
  const poolData = async () => {
    const pageViewsResponse = await GoogleAnalyticsService.getViewsByPage(props.views.query.ids, props.pagePath);
    setPageViews(pageViewsResponse);
  }
  return (
    <div className='col-12 white-background col'>
      <Row>
        <Col className='col-6'>
          <h5 className="activeUsers">
            {/* <h3>Active users right now: <span>{activeUsers}</span></h3> */}
            {activeUsers !== null && <>Active users right now: <span>{activeUsers}</span></>}
            {activeUsers === null && `Getting active users information ...`}
          </h5>
        </Col>
        <Col className='col-6'>
          <h5 className="activeUsers">
            {pageViews !== null && <>Page views: <span>{pageViews}</span></>}
            {pageViews === null && `Getting page views information ...`}
          </h5>
        </Col>
      </Row>
    </div>
  )
}
